
<div>
  <div
    v-if="showMobileFilters"
    class="drawer-overlay"
    @click="closeDrawer"
  ></div>

  <div
    :class="[
      'filters-container w-full flex flex-col font-rubik mb-2 mobile-drawer',
      { open: showMobileFilters }
    ]"
  >
    <div class="sections-bottom-border flex justify-between">
      <h3 class="p-3 component-name">Filters</h3>
      <button class="p-3 lg:hidden" @click="closeDrawer">X</button>
    </div>

    <div class="sections-bottom-border" v-if="!isRentalsPage">
      <div class="p-3">
        <h4 class="filter-name">Condition</h4>
        <div v-for="(value, label) in filteredConditions" :key="value">
          <label class="filter-checkbox">
            <input
              type="checkbox"
              @change="update('condition', value)"
              :checked="filters.condition.includes(value)"
            />
            {{ label }}
          </label>
        </div>
      </div>
    </div>

    <div class="sections-bottom-border">
      <div class="p-3">
        <h4 class="filter-name">Size</h4>
        <div v-for="(label, size) in sizes" :key="size">
          <label class="filter-radio">
            <input
              type="radio"
              name="size"
              @change="update('size', size)"
              :value="size"
              :checked="filters.size === size"
            />
            {{ label }}
          </label>
        </div>
      </div>
    </div>

    <div class="p-3" v-if="!isRentalsPage && Object.keys(usageType).length > 1">
      <h4 class="filter-name">Usage Type</h4>
      <div v-for="(option, label) in usageType" :key="option">
        <label class="filter-radio">
          <span class="flex items-center gap-2">
            <input
              type="radio"
              name="usage-type"
              @change="update('usageType', option)"
              :checked="filters.usageType === option"
            />
            <icon
              :type="option"
              style="max-width: 16px !important; max-height: 16px !important;"
            />
            <label>{{ label }}</label>
          </span>
        </label>
      </div>
    </div>

    <div class="mobile-selected-filters lg:hidden p-3 flex flex-wrap gap-2">
      <button
        v-for="filter in selectedFilters"
        :key="filter.text"
        @click="removeFilter(filter)"
        class="filter-button"
      >
        <span class="text-[10px]">{{ filter.text }}</span>
        <img
          class="inline pl-2"
          src="@/images/partners-page/clear.svg"
          :alt="`Clear ${filter.text} filter`"
        />
      </button>
    </div>
  </div>
</div>
